export default {
    status: {
        'in-progress': 'En curso',
        'IN-PROGRESS': 'En curso',
        ACTIVE: 'Activo',
        BLOCKED: 'Bloqueado',
        open: 'Pendiente',
        OPEN: 'Pendiente',
        PENDIENTE: 'Pendiente',
        PENDING: 'Pendiente',
        RD_SENT: 'Enviado',
        ENVIADO: 'Enviado',
        resolved: 'Resuelta',
        RESOLVED: 'Resuelta',
        FINALIZADO: 'Finalizado',
        FINALIZED: 'Finalizada',
        VALIDADO: 'Validado',
        VALIDATED: 'Validado',
        REGISTERED_ONLINE: 'Alta online',
        REGISTERED_EMAIL: 'Alta email',
        REGISTERED_POSTAL: 'Alta postal',
        REGISTERED: 'Alta',
        SIGNED: 'Firmado',
        BLOQUEADO: 'Bloqueado'
    },
    categories: {
        DOCUMENTATION: 'Documentación',
        LEGAL: 'Legal',
        COMPLIANCE: 'Conformidad',
        CASH_FLOW: 'Efectivo',
        ADMINISTRATION: 'Administración',
        INTERVENER_CARE: 'Relación con inversores'
    },
    object_type: {
        ACCOUNT: 'Cuenta',
        INTERVENER: 'Interviniente',
        OPERATION: 'Operación'
    },
    blocking: {
        true: 'Bloqueante',
        false: 'No bloqueante'
    }
};
